<template>
  <div>
    <!-- 视频、图片 -->
    <q-dialog
      :visible.sync="dialogVisible"
      :title="detailData.title"
      width="700px"
      :innerHeight="520"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
      :showFooter="false"
      v-esc-close
    > 
      <div class="video-wrap" v-if="+detailType === 1">
        <video
          v-if="detailData.video"
          :src="detailData.video"
          controls="controls"
          width="600"
          height="400"
        >
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div class="pic-wrap" v-if="+detailType === 0">
        <el-carousel
          height="500px"
          arrow="always"
          :autoplay="false"
          trigger="click"
        >
          <el-carousel-item v-for="item in detailData.pictures" :key="item">
            <el-image :src="item" fit="contain" class="pic-item"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'data','detailType'],
  data() {
    return {
      detailData: {},
      dialogVisible: false
    }
  },
  mounted() {
    let video = "";
    const pictures = [];

    // type: 1 video, 0 picture
    this.data.picList.forEach((item) => {
      if (+item.mediaType === 1) {
        video = item.path;
      } else {
        pictures.push(item.path);
      }
    });

    this.detailData = {
      video,
      pictures,
      title: this.detailType === 1 ? "视频" : "图片",
    };
    this.dialogVisible = this.visible;
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.updateVal();
    }
  }
}
</script>

<style lang="stylus" scoped>
  .pic-item
    width 100%
    height 500px
</style>